<template>
  <div class="layout-main bg-gray-200">
    <the-navbar />
    <div class="router-wrapper">
      <router-view />
    </div>
    <the-footer v-if="!isPro" />
    <biew-badge v-if="!isPro" />
  </div>
</template>

<script>
import BiewBadge from "@/components/BiewBadge";
import TheFooter from "@/components/TheFooter";
import TheNavbar from "@/components/TheNavbar";

export default {
  name: "Main",

  components: {
    BiewBadge,
    TheFooter,
    TheNavbar
  },

  computed: {
    isPro() {
      return this.$store.state.config.isPro;
    }
  }
};
</script>

<style lang="scss" scoped>
.router-wrapper {
  box-sizing: border-box;
  padding: 30px;
  min-height: 93vh;
}
</style>
